import React, { useState, useEffect, useRef } from 'react';
import { BskyAgent } from '@atproto/api';
import styles from './Showcase.module.css';

function GoLiveBotBluesky() {
  const [agent, setAgent] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [originalDisplayName, setOriginalDisplayName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [originalDescription, setOriginalDescription] = useState('');
  const [originalAvatar, setOriginalAvatar] = useState(''); // Store original profile image
  const [previewImage, setPreviewImage] = useState(null);
  const [originalBanner, setOriginalBanner] = useState('');
  const [bannerPreview, setBannerPreview] = useState(null);
  const [user, setUser] = useState(null);

  // Banner Customization State
  const [text1, setText1] = useState("🔴 NOW LIVE");
  const [text2, setText2] = useState("twitch.tv/Joptimist");
  // Set default text positions (centered)
  const [text1X, setText1X] = useState(50); // 50% -> center
  const [text1Y, setText1Y] = useState(40); // 40% -> slightly above center
  const [text2X, setText2X] = useState(50); // 50% -> center
  const [text2Y, setText2Y] = useState(70); // 60% -> slightly below center
  const [fontSize, setFontSize] = useState(100);
  const [textColor, setTextColor] = useState("black");
  const [fontFamily, setFontFamily] = useState("Arial");
  const [bgColor, setBgColor] = useState("#000000");
  const [bgOpacity, setBgOpacity] = useState(0.5);
  const canvasRef = useRef(null);


  useEffect(() => {
      fetch("https://dev.super-stream.co/auth/user", { credentials: "include" })
          .then((res) => res.json())
          .then((data) => {
              if (data.profile) setUser(data.profile);
          })
          .catch(() => setUser(null));
  }, []);

  const loginToBluesky = async () => {
    try {
      const newAgent = new BskyAgent({ service: 'https://bsky.social' });
      await newAgent.login({
        identifier: 'testjoptimist.bsky.social', // Replace with user's handle
        password: '3snt-xyi2-xyji-u7wt', // Use an App Password (DO NOT expose in production)
      });

      setAgent(newAgent);
      setIsLoggedIn(true);
      fetchUserProfile(newAgent);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  useEffect(() => {
    renderBannerPreview();
  }, [originalBanner]); // 👈 Empty array ensures it runs only once at startup

  const fetchUserProfile = async (agent) => {
    try {
        const profile = await agent.getProfile({ actor: agent.session.did });
        setOriginalDisplayName(profile.data.displayName);
        setDisplayName(profile.data.displayName);
        setOriginalDescription(profile.data.description || '');
        
        console.log("avatar", profile.data.avatar);
        console.log("banner", profile.data.banner);

        let originalAvatarBlob = null;
        let originalBannerBlob = null;

        // Process live versions
        const proxyAvatarUrl = await fetchProxyAvatar(profile.data.avatar);
        const proxyBannerUrl = await fetchProxyAvatar(profile.data.banner);

        if (profile.data.avatar) {
            const avatarBlob = await fetchImageAsBlob(proxyAvatarUrl, true, false);
            originalAvatarBlob = avatarBlob;
            setOriginalAvatar(avatarBlob);
        }

        if (profile.data.banner) {
            const bannerBlob = await fetchImageAsBlob(proxyBannerUrl, false, true);
            originalBannerBlob = bannerBlob;
            setOriginalBanner(URL.createObjectURL(bannerBlob)); // ✅ Store BLOB as URL for preview
        }
        
        const newAvatarDataUrl = await overlayLiveRing(proxyAvatarUrl);
        const newBannerDataUrl = await overlayLiveBanner(proxyBannerUrl);

        const liveAvatarBlob = await fetchImageAsBlob(newAvatarDataUrl, true, false);
        const liveBannerBlob = await fetchImageAsBlob(newBannerDataUrl, false, true);

        setPreviewImage(newAvatarDataUrl);

        await saveAvatarsToMongoDB(
            localStorage.getItem("_id"),
            originalAvatarBlob, liveAvatarBlob,
            originalBannerBlob, liveBannerBlob,
            profile.data.displayName,
            profile.data.description
        );

    } catch (error) {
        console.error('Error fetching profile:', error);
    }
};


  const fetchImageAsBlob = async (imageData, isAvatar, isBanner) => {
    try {
      let response;
      if (imageData.startsWith("data:image")) {
        response = await fetch(imageData);
      } else {
        const proxiedUrl = await fetchProxyAvatar(imageData);
        response = await fetch(proxiedUrl);
      }
  
      const blob = await response.blob();
      let croppedBlob;
      if(isAvatar){
        croppedBlob = await cropImageCenter(blob, 400, 400); // Crop before returning
      }
      else if(isBanner){
        croppedBlob = await cropImageCenter(blob, 1500, 500); // Crop before returning
      }
  
      return croppedBlob;
    } catch (error) {
      console.error("❌ Error converting image to Blob:", error);
      return null;
    }
  };

  const cropImageCenter = (blob, targetWidth, targetHeight) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(blob);
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        canvas.width = targetWidth;
        canvas.height = targetHeight;
  
        // Find center crop dimensions
        const aspectRatio = targetWidth / targetHeight;
        let cropWidth = img.width;
        let cropHeight = img.width / aspectRatio;
  
        if (cropHeight > img.height) {
          cropHeight = img.height;
          cropWidth = img.height * aspectRatio;
        }
  
        const startX = (img.width - cropWidth) / 2;
        const startY = (img.height - cropHeight) / 2;
  
        // Crop & draw the center 1500x500 area
        ctx.drawImage(img, startX, startY, cropWidth, cropHeight, 0, 0, targetWidth, targetHeight);
  
        // Convert to Blob
        canvas.toBlob((croppedBlob) => {
          resolve(croppedBlob);
        }, "image/jpeg", 0.9); // JPEG format to reduce size
      };
    });
  };
  

  const saveAvatarsToMongoDB = async (
    userId, originalAvatarBlob, liveAvatarBlob,
    originalBannerBlob, liveBannerBlob,
    blueskyDisplayName, blueskyDescription
) => {
    const readerOriginalAvatar = new FileReader();
    const readerLiveAvatar = new FileReader();
    const readerOriginalBanner = new FileReader();
    const readerLiveBanner = new FileReader();

    readerOriginalAvatar.readAsDataURL(originalAvatarBlob);
    readerLiveAvatar.readAsDataURL(liveAvatarBlob);
    readerOriginalBanner.readAsDataURL(originalBannerBlob);
    readerLiveBanner.readAsDataURL(liveBannerBlob);

    readerOriginalAvatar.onloadend = () => {
        const originalAvatarBase64 = readerOriginalAvatar.result;

        readerLiveAvatar.onloadend = () => {
            const liveAvatarBase64 = readerLiveAvatar.result;

            readerOriginalBanner.onloadend = () => {
                const originalBannerBase64 = readerOriginalBanner.result;

                readerLiveBanner.onloadend = async () => {
                    const liveBannerBase64 = readerLiveBanner.result;

                    await fetch("https://dev.super-stream.co/api/save-avatars-bluesky", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            userId,
                            originalAvatar: originalAvatarBase64,
                            liveAvatar: liveAvatarBase64,
                            originalBanner: originalBannerBase64,
                            liveBanner: liveBannerBase64,
                            originalBlueskyDisplayName: blueskyDisplayName,
                            originalBlueskyDescription: blueskyDescription
                        }),
                    });

                    console.log("✅ Avatars & Banners stored in MongoDB!");
                };
            };
        };
    };
};



  const getProfileRkey = async () => {
    if (!agent) return null;

    try {
      const response = await agent.api.com.atproto.repo.listRecords({
        repo: agent.session.did,
        collection: 'app.bsky.actor.profile',
      });

      if (response.data.records.length > 0) {
        const profileRecord = response.data.records[0];
        return profileRecord.uri.split('/').pop();
      } else {
        console.error("No profile record found.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching profile record:", error);
      return null;
    }
  };

  const fetchImageMimeType = async (imageUrl) => {
    try {
        const response = await fetch(imageUrl, { method: "HEAD" }); // Fetch headers only
        const contentType = response.headers.get("Content-Type");
        console.log("🔹 Original Avatar MIME Type:", contentType);
        return contentType || "image/jpeg"; // Default to JPEG if unknown
    } catch (error) {
        console.error("❌ Error fetching MIME type:", error);
        return "image/jpeg"; // Default to JPEG to prevent Bluesky errors
    }
};

const overlayLiveBanner = async (originalBannerUrl) => {
  try {
      const mimeType = await fetchImageMimeType(originalBannerUrl);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const bannerImage = new Image();
      bannerImage.crossOrigin = "anonymous";
      bannerImage.src = originalBannerUrl;

      return new Promise((resolve) => {
          bannerImage.onload = () => {
              canvas.width = bannerImage.width;
              canvas.height = bannerImage.height;

              ctx.drawImage(bannerImage, 0, 0, bannerImage.width, bannerImage.height);

              // Add "NOW LIVE" text overlay
              ctx.font = "bold 60px Arial";
              ctx.fillStyle = "red";
              ctx.textAlign = "center";
              ctx.fillText("🔴 NOW LIVE", canvas.width / 2, canvas.height / 2);
              ctx.fillText("twitch.tv/Joptimist", canvas.width / 2, canvas.height / 2);
              ctx.fillStyle = "yellow";
              ctx.fillText("super-stream.co", canvas.width / 2, 4 * (canvas.height / 5));

              resolve(canvas.toDataURL(mimeType));
          };
      });

  } catch (error) {
      console.error("❌ Error overlaying live banner:", error);
      return null;
  }
};


  const overlayLiveRing = async (originalAvatarUrl) => {
    try {
      const mimeType = await fetchImageMimeType(originalAvatarUrl); // Get original MIME type
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const avatarImage = new Image();
        avatarImage.crossOrigin = "anonymous";
        avatarImage.src = originalAvatarUrl;

        const liveOverlay = new Image();
        liveOverlay.crossOrigin = "anonymous";
        liveOverlay.src = 'redcircle.png'; 

        return new Promise((resolve) => {
            avatarImage.onload = () => {
                console.log("✅ avatarImage loaded:", avatarImage.width, avatarImage.height);

                // Set canvas size to avatar's exact dimensions
                canvas.width = avatarImage.width;
                canvas.height = avatarImage.height;

                // Draw the avatar
                ctx.drawImage(avatarImage, 0, 0, avatarImage.width, avatarImage.height);

                // If liveOverlay is already loaded, draw it immediately
                if (liveOverlay.complete) {
                    console.log("✅ liveOverlay already loaded, drawing immediately");
                    drawOverlayAndResolve();
                } else {
                    // Otherwise, wait for it to load
                    liveOverlay.onload = () => {
                        console.log("✅ liveOverlay loaded, drawing now");
                        drawOverlayAndResolve();
                    };
                }

                function drawOverlayAndResolve() {
                    console.log("✅ Scaling overlay to match avatar size:", avatarImage.width, avatarImage.height);

                    // Draw overlay to exactly match the avatar's dimensions
                    ctx.drawImage(liveOverlay, 0, 0, avatarImage.width, avatarImage.height);

                    console.log("✅ Overlay applied successfully");
                    resolve(canvas.toDataURL(mimeType)); // Return modified image
                }
            };

            avatarImage.onerror = () => console.error("❌ Error loading avatar image");
            liveOverlay.onerror = () => console.error("❌ Error loading overlay image");
        });

    } catch (error) {
        console.error("❌ Error overlaying live ring:", error);
        return null;
    }
};


const getMimeTypeFromBase64 = (base64String) => {
  const match = base64String.match(/^data:(.+);base64,/);
  return match ? match[1] : null; // Returns MIME type (e.g., "image/png")
};

const uploadImageToBluesky = async (imageDataUrl) => {
  try {
      console.log("🔹 Uploading Avatar to Bluesky...");
      console.log("🔹 Image Data URL:", imageDataUrl);
      // Convert Data URL (base64) to Blob
      const base64Data = imageDataUrl.split(',')[1]; // Remove "data:image/png;base64,"
      const binaryData = atob(base64Data);
      const arrayBuffer = new Uint8Array(binaryData.length);
      const mimeType = getMimeTypeFromBase64(imageDataUrl);

      for (let i = 0; i < binaryData.length; i++) {
          arrayBuffer[i] = binaryData.charCodeAt(i);
      }

      const imageBlob = new Blob([arrayBuffer], { type: mimeType });

      console.log("🔹 Converted Image Blob:", imageBlob);
      console.log("🔹 Converted Image Blob size:", imageBlob.size);

      // Upload to Bluesky
      const response = await agent.api.com.atproto.repo.uploadBlob(imageBlob);

      console.log("🔹 Bluesky Upload Response:", response);

      if (response.data) {
        let blobUri;
        if (response.data.blob.ref["$link"]) {
            blobUri = response.data.blob.ref["$link"];
        } else if (response.data.blob.ref._baseCache) {
            blobUri = response.data.blob.ref._baseCache.get("b");
        } else {
            console.error("No valid blob URI found.");
        }
        return blobUri;
      } else {
          console.error("❌ Error: No blob reference returned from Bluesky.");
          return null;
      }
  } catch (error) {
      console.error("❌ Error uploading image to Bluesky:", error);
      return null;
  }
};


const updateProfile = async (newName, newDescription, newAvatarUri, newBannerUri, avatarMimeType, bannerMimeType) => {
  if (!agent) return;

  try {
      console.log("🔹 Fetching profile record to update...");

      const rkey = await getProfileRkey();
      if (!rkey) {
          console.error("❌ No profile record found.");
          return;
      }

      // Fetch the current profile data
      const profileResponse = await agent.api.com.atproto.repo.getRecord({
          repo: agent.session.did,
          collection: 'app.bsky.actor.profile',
          rkey: rkey,
      });

      const existingData = profileResponse.data.value;

      console.log("🔹 Existing Profile Data:", existingData);

      // ✅ Ensure `avatar` & `banner` follow Bluesky's expected structure
      const updatedAvatar = newAvatarUri ? {
          "$type": "blob",
          "ref": { "$link": newAvatarUri }, // ✅ Use correct Bluesky Blob URI
          "mimeType": avatarMimeType,
          "size": 302748 // (Can be dynamically set based on uploaded file size)
      } : existingData.avatar; // Keep the existing avatar if no new one

      const updatedBanner = newBannerUri ? {
          "$type": "blob",
          "ref": { "$link": newBannerUri }, // ✅ Use correct Bluesky Blob URI
          "mimeType": bannerMimeType,
          "size": 302748 // (Can be dynamically set based on uploaded file size)
      } : existingData.banner; // Keep the existing banner if no new one

      console.log("🔹 Updating profile with:", {
          displayName: newName,
          description: newDescription,
          avatar: updatedAvatar,
          banner: updatedBanner
      });

      // ✅ Send the PUT request to update the profile
      const updateResponse = await agent.api.com.atproto.repo.putRecord({
          repo: agent.session.did,
          collection: 'app.bsky.actor.profile',
          rkey: rkey,
          record: {
              ...existingData, // Preserve all other fields
              displayName: newName,
              description: newDescription,
              avatar: updatedAvatar, // ✅ Ensure avatar is updated properly
              banner: updatedBanner  // ✅ Ensure banner is updated properly
          },
      });

      console.log("✅ Profile successfully updated!", updateResponse);

      setDisplayName(newName);
      console.log(`✅ Profile updated: ${newName}, Bio: ${newDescription}, Avatar: ${newAvatarUri}, Banner: ${newBannerUri}`);
  } catch (error) {
      console.error("❌ Error updating profile:", error);
  }
};


  const fetchProxyAvatar = async (originalAvatarUrl) => {
    try {
        const proxyUrl = `https://dev.super-stream.co/api/proxy-avatar-bluesky?url=${encodeURIComponent(originalAvatarUrl)}`;
        return proxyUrl; // Use this URL in your overlay function
    } catch (error) {
        console.error("Error proxying avatar:", error);
        return null;
    }
};

const goLive = async () => {
  const liveName = `🔴 ${displayName}`;
  const liveDescription = `🔴 LIVE NOW! ${originalDescription}`;

  // ✅ Generate the branded banner for upload
  const finalLiveBanner = await generateFinalLiveBanner();
  if (!finalLiveBanner) {
    console.error("❌ Failed to generate live banner.");
    return;
  }

  // Upload images
  const restoredAvatarUri = await uploadImageToBluesky(previewImage);
  const restoredBannerUri = await uploadImageToBluesky(finalLiveBanner);
  if (!restoredAvatarUri || !restoredBannerUri) return;

  const mimeTypeAvatar = getMimeTypeFromBase64(previewImage);
  const mimeTypeBanner = getMimeTypeFromBase64(finalLiveBanner);

  console.log("✅ Live Avatar & Banner Re-uploaded:", restoredAvatarUri, restoredBannerUri);

  updateProfile(liveName, liveDescription, restoredAvatarUri, restoredBannerUri, mimeTypeAvatar, mimeTypeBanner);
};



const endLive = async () => {
  console.log("🔹 Restoring original assets from MongoDB...");

  const avatars = await fetchUserAvatars(localStorage.getItem("_id"));
  if (!avatars || !avatars.originalAvatar || !avatars.originalBanner) {
      console.error("❌ Failed to retrieve original assets.");
      return;
  }

  const restoredAvatarUri = await uploadImageToBluesky(avatars.originalAvatar);
  const restoredBannerUri = await uploadImageToBluesky(avatars.originalBanner);
  if (!restoredAvatarUri || !restoredBannerUri) return;

  const mimeTypeAvatar = getMimeTypeFromBase64(avatars.originalAvatar);
  const mimeTypeBanner = getMimeTypeFromBase64(avatars.originalBanner);

  console.log("✅ Original Avatar & Banner Re-uploaded:", restoredAvatarUri, restoredBannerUri);

  updateProfile(avatars.blueskyDisplayName, avatars.blueskyDescription, restoredAvatarUri, restoredBannerUri, mimeTypeAvatar, mimeTypeBanner);
};


// not jsut avatars bbut also description and name
const fetchUserAvatars = async (userId) => {
  try {
      const response = await fetch(`https://dev.super-stream.co/api/get-avatars-bluesky?userId=${userId}`);
      const data = await response.json();

      if (!data.success || !data.originalAvatar) {
          console.error("❌ No avatars found.");
          return null;
      }

      console.log("✅ Retrieved Avatars:", data);
      return data; // { originalAvatar, liveAvatar }
  } catch (error) {
      console.error("❌ Error fetching avatars:", error);
      return null;
  }
};


// Function to render customized banner on canvas
const renderBannerPreview = () => {
  if (!originalBanner) return;

  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");
  const bannerImage = new Image();
  bannerImage.crossOrigin = "anonymous";
  bannerImage.src = originalBanner;

  bannerImage.onload = () => {
    canvas.width = 1500;
    canvas.height = 500;

    // Maintain aspect ratio
    let imgWidth = 1500;
    let imgHeight = (bannerImage.height / bannerImage.width) * imgWidth;
    if (imgHeight < 500) {
      imgHeight = 500;
      imgWidth = (bannerImage.width / bannerImage.height) * imgHeight;
    }

    const xOffset = (1500 - imgWidth) / 2;
    const yOffset = (500 - imgHeight) / 2;

    // Draw banner resized to 1500x500
    ctx.drawImage(bannerImage, xOffset, yOffset, imgWidth, imgHeight);

    // Background overlay
    ctx.fillStyle = `rgba(${parseInt(bgColor.slice(1, 3), 16)},${parseInt(bgColor.slice(3, 5), 16)},${parseInt(bgColor.slice(5, 7), 16)},${bgOpacity})`;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Convert % positions to pixel positions
    const text1XPos = (text1X / 100) * 1500;
    const text1YPos = (text1Y / 100) * 500;
    const text2XPos = (text2X / 100) * 1500;
    const text2YPos = (text2Y / 100) * 500;

    // Draw text 1
    ctx.font = `${fontSize}px ${fontFamily}`;
    ctx.fillStyle = textColor;
    ctx.textAlign = "center";
    ctx.fillText(text1, text1XPos, text1YPos);

    // Draw text 2
    ctx.fillText(text2, text2XPos, text2YPos);

    // Update preview
    setBannerPreview(canvas.toDataURL());
  };
};


useEffect(() => {
  renderBannerPreview();
}, [text1, text2, text1X, text1Y, text2X, text2Y, fontSize, textColor, fontFamily, bgColor, bgOpacity]);

const generateFinalLiveBanner = async () => {
  return new Promise((resolve) => {
    if (!originalBanner) return resolve(null);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const bannerImage = new Image();
    bannerImage.crossOrigin = "anonymous";
    bannerImage.src = originalBanner;

    bannerImage.onload = () => {
      canvas.width = 1500;
      canvas.height = 500;

      // Maintain aspect ratio
      let imgWidth = 1500;
      let imgHeight = (bannerImage.height / bannerImage.width) * imgWidth;
      if (imgHeight < 500) {
        imgHeight = 500;
        imgWidth = (bannerImage.width / bannerImage.height) * imgHeight;
      }

      const xOffset = (1500 - imgWidth) / 2;
      const yOffset = (500 - imgHeight) / 2;

      // Draw banner resized to 1500x500
      ctx.drawImage(bannerImage, xOffset, yOffset, imgWidth, imgHeight);

      // Background overlay
      ctx.fillStyle = `rgba(${parseInt(bgColor.slice(1, 3), 16)},${parseInt(bgColor.slice(3, 5), 16)},${parseInt(bgColor.slice(5, 7), 16)},${bgOpacity})`;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Convert % positions to pixel positions
      const text1XPos = (text1X / 100) * 1500;
      const text1YPos = (text1Y / 100) * 500;
      const text2XPos = (text2X / 100) * 1500;
      const text2YPos = (text2Y / 100) * 500;

      // Draw text 1
      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.fillStyle = textColor;
      ctx.textAlign = "center";
      ctx.fillText(text1, text1XPos, text1YPos);

      // Draw text 2
      ctx.fillText(text2, text2XPos, text2YPos);

      // ✅ Add "super-stream.co" branding (only for uploaded version)
      ctx.fillStyle = "yellow";
      ctx.font = `bold 25px ${fontFamily}`;
      ctx.fillText("super-stream.co", 1400, 425);

      resolve(canvas.toDataURL());
    };
  });
};

const handleLogin = () => {
  const authURL = `https://id.twitch.tv/oauth2/authorize?client_id=gwh81zlp83y1urhl9jv1lqjmottg1w&redirect_uri=https://dev.super-stream.co/auth/twitch/callback/&response_type=code&scope=user:read:email`;
  window.location.href = authURL;
};

const handleLogout = () => {
  // fetch("https://dev.super-stream.co/logout", { credentials: "include" }).then(() => setUser(null));
};

return (
  <div className={styles.container}>
    <h2>Bluesky Authentication</h2>

    {!isLoggedIn ? (
      <>
        <button onClick={loginToBluesky}>Login to Bluesky</button>
        <div style={{ textAlign: "center", marginTop: "50px" }}>
              <h1>Twitch OAuth with MERN</h1>
              {user ? (
                <>
                      <h2>Welcome, {user.display_name}!</h2>
                      <img src={user.profile_image_url} alt="Twitch Avatar" width="100" />
                      <p>Email: {user.email}</p>
                      <button onClick={handleLogout}>Logout</button>
                  </>
              ) : (
                <button onClick={handleLogin}>Login with Twitch</button>
              )}
        </div>
      </>
    ) : (
      <div>
        <p>Logged in as: {displayName}</p>

        {/* 🚀 Editable Display Name & Description */}
        <label>
          Live Display Name (max 640 chars): 
          <input 
            type="text" 
            value={displayName} 
            maxLength={640} 
            onChange={(e) => setDisplayName(e.target.value)} 
          />
        </label>

        <label>
          Live Description (max 2560 chars): 
          <textarea 
            value={originalDescription} 
            maxLength={2560} 
            onChange={(e) => setOriginalDescription(e.target.value)} 
            rows={4}
          />
        </label>

        {/* 🚀 Go Live & End Live Buttons */}
        <button onClick={goLive} style={{ marginRight: '10px' }}>
          Go Live (🔴 Update Avatar, Banner & Bio)
        </button>
        <button onClick={endLive}>
          End Live (Reset Profile)
        </button>

        <h3>Banner Editor</h3>

        {/* Text Inputs */}
        <label>Text 1: <input type="text" value={text1} onChange={(e) => setText1(e.target.value)} /></label>
        <label>X (%): <input type="number" min="0" max="100" value={text1X} onChange={(e) => setText1X(Number(e.target.value))} /></label>
        <label>Y (%): <input type="number" min="0" max="100" value={text1Y} onChange={(e) => setText1Y(Number(e.target.value))} /></label>

        <label>Text 2: <input type="text" value={text2} onChange={(e) => setText2(e.target.value)} /></label>
        <label>X (%): <input type="number" min="0" max="100" value={text2X} onChange={(e) => setText2X(Number(e.target.value))} /></label>
        <label>Y (%): <input type="number" min="0" max="100" value={text2Y} onChange={(e) => setText2Y(Number(e.target.value))} /></label>

        {/* Font Customization */}
        <label>Font Size: <input type="number" value={fontSize} onChange={(e) => setFontSize(Number(e.target.value))} /></label>
        <label>Font Family: 
          <select value={fontFamily} onChange={(e) => setFontFamily(e.target.value)}>
            <option value="Arial">Arial</option>
            <option value="Verdana">Verdana</option>
            <option value="Tahoma">Tahoma</option>
            <option value="Georgia">Georgia</option>
            <option value="Impact">Impact</option>
          </select>
        </label>
        <label>Text Color: <input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} /></label>

        {/* Background Customization */}
        <label>Background Color: <input type="color" value={bgColor} onChange={(e) => setBgColor(e.target.value)} /></label>
        <label>Background Opacity: <input type="range" min="0" max="1" step="0.1" value={bgOpacity} onChange={(e) => setBgOpacity(Number(e.target.value))} /></label>

        {/* Canvas Preview */}
        <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
        {bannerPreview && <img src={bannerPreview} alt="Banner Preview" style={{ width: "100%" }} />}

        <button onClick={renderBannerPreview}>Update Preview</button>
      </div>
    )}
  </div>
);


}

export default GoLiveBotBluesky;
